import useTheme from '@/utils/hooks/useTheme'
import { UserPreference } from '@/utils/hooks/useUserPreference'
import clsx from 'clsx'
import { HTMLAttributes } from 'react'
import { Button } from '@mantine/core'
import styles from './ThemeSwitcher.module.css'

const THEME_LOCALE: Record<UserPreference['theme'], string> = {
	AUTO: '自动',
	LIGHT: '浅色',
	DARK: '深色',
}

export default function ThemeSwitcher({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
	const [theme, setTheme] = useTheme()

	return (
		<div className={clsx(styles.root, className)} {...props}>
			{Object.entries(THEME_LOCALE).map(([key, label]) => {
				const isActive = key === theme
				return (
					<Button
						variant={isActive ? 'outline' : 'transparent'}
						size="sm"
						key={key}
						onClick={() => {
							setTheme(key as UserPreference['theme'])
						}}
					>
						{label}
					</Button>
				)
			})}
		</div>
	)
}
